import { T } from "@repo/transifex";
import { type Currency } from "~/api/products/types";
import { type FlexMenuWithProductsByCategory } from "~/api/menus/hooks/use-get-menus";

import { OrdersList } from "../__app.collect.orders/basket/orders-list";
import { type TakeCandidate } from "../__app.collect.orders.create/use-collect-debt-gate";

import { MenuItem } from "./menu-item";

type MenuListProps = {
  menu: FlexMenuWithProductsByCategory;
  currency: Currency;
  childId: string;
  takeCandidate: TakeCandidate;
};

export const MenuList = ({
  menu,
  currency,
  childId,
  takeCandidate
}: MenuListProps) => {
  return (
    <div className="flex flex-col gap-4 p-3">
      <div className="flex flex-row items-center justify-between">
        <p className="text-xl font-bold">{menu.name}</p>

        <p className="text-sm text-interface-neutral-5">
          <T _str="Choose 1" />
        </p>
      </div>

      {Object.entries(menu.productsByCategory).map(
        ([categoryId, { products, categoryName }]) => (
          <div key={categoryId} className="flex flex-col gap-4">
            {categoryName ? (
              <p className="text-lg font-semibold text-interface-neutral-5">
                {categoryName}
              </p>
            ) : null}

            <OrdersList variant="menu">
              {products.map((product) => (
                <MenuItem
                  key={product.id}
                  product={product}
                  variants={menu.variants}
                  moduleId={menu.moduleId}
                  discounts={menu.discounts}
                  currency={currency}
                  childId={childId}
                  takeCandidate={takeCandidate}
                />
              ))}
            </OrdersList>
          </div>
        )
      )}
    </div>
  );
};
